import { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import * as dashboardActions from '../../core/dashboard/dashboardActions';

import DOM from './statistics';

class StatisticsPage extends Component {
    constructor(props) {
        super(props);
        this.view = DOM;

        this.state = {
            title: 'Statistics',
        };
    }

    componentDidMount() {
        this.props.actions.getDashboardStatsRequest();
    }

    render() {
        return this.view();
    }
}

StatisticsPage.propTypes = {
    actions: PropTypes.object.isRequired,
    // dashboard: PropTypes.object.isRequired,
};

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        dashboard: state.dashboard,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...dashboardActions
        }, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(StatisticsPage);
